var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar-item-dropdown',{attrs:{"text":("Здравствуйте, " + _vm.username),"items":_vm.items,"right":""}})}
var staticRenderFns = []

export { render, staticRenderFns }